require('./bootstrap');
import util from './util';
import api from './api';
import Swal from 'sweetalert2';
import flatpickr from "flatpickr";
import moment from 'moment';
import i18next from 'i18next';
import { Korean } from "flatpickr/dist/l10n/ko.js"
import { Japanese } from "flatpickr/dist/l10n/ja.js"
import translation from './translation.json'
import flatpickrUtil from './flatpickrJS'
import Sortable from 'sortablejs';
import uuidv4 from './uuid';

require("flatpickr/dist/themes/material_blue.css");

i18next.init({
  lng: 'en',
  debug: false,
  resources: translation,
  ns: "translation"
});

const Toast = Swal.mixin({
  icon: "success",
  toast: true,
  timer: 3000,
  position: 'top-end',
  showConfirmButton: false,
});


var Turbolinks = require("turbolinks")
var first = true

window.util = util;
window.api = api;
window.Swal = Swal
window.Toast = Toast
window.flatpickr = flatpickr
window.moment = moment
window.jp = Japanese
window.ko = Korean
window.i18next = i18next
window.Sortable = Sortable
window.uuidv4 = uuidv4
window.flatpickrUtil = flatpickrUtil

document.addEventListener("turbolinks:load", () => {
  if(first) {
    first = false
    return
  }
  window.livewire.restart();
});

Turbolinks.start()